/* Shopify commerce for the approved photo-story design. */
(() => {
  function init() {
    const dataNode = document.getElementById('photo-story-product');
    if (!dataNode) return;
    window.photoStoryCleanup?.();
    const controller = new AbortController();
    const { signal } = controller;
    const on = (node, event, handler) => node?.addEventListener(event, handler, { signal });
    const $ = selector => document.querySelector(selector);
    const data = JSON.parse(dataNode.textContent);
    // Older catalog descriptions contain the label as inline rich text.
    // Move only identified supplement-facts content into the existing modal.
    const description = $('.product-rich-description');
    if (description) {
      const factsTitle = /^(supplement|nutrition|nutritional)\s+facts\s*:?$/i;
      const factsAlt = /(?:supplement|nutrition|nutritional)\s+facts/i;
      const labelImages = new Set([...description.querySelectorAll('img')].filter(img => factsAlt.test(img.alt)));
      for (const heading of description.querySelectorAll('h1,h2,h3,h4,h5,h6')) {
        if (!factsTitle.test(heading.textContent.trim())) continue;
        let sibling = heading.nextElementSibling;
        while (sibling && !/^H[1-6]$/.test(sibling.tagName)) {
          const img = sibling.matches('img') ? sibling : sibling.querySelector('img');
          if (img) { labelImages.add(img); break; }
          if (sibling.textContent.trim()) break;
          sibling = sibling.nextElementSibling;
        }
        if (sibling && labelImages.size) heading.remove();
      }
      for (const img of labelImages) {
        if (!data.label) data.label = img.currentSrc || img.src;
        img.remove();
      }
      // Remove the empty paragraphs and spacer headings left by catalog HTML.
      [...description.querySelectorAll('p,span,strong,em,h1,h2,h3,h4,h5,h6')].reverse().forEach(node => {
        const empty = /^(SPAN|STRONG|EM)$/.test(node.tagName) ? !node.textContent.length : !node.textContent.trim();
        if (empty && !node.querySelector('img,video,iframe,svg,table')) node.remove();
      });
      // Trim trailing line breaks, including those inside rich-text wrappers.
      // Line breaks between actual paragraphs remain intact.
      const trimEnd = container => {
        while (container.lastChild) {
          const node = container.lastChild;
          if (node.nodeType === Node.COMMENT_NODE ||
              (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) ||
              node.nodeName === 'BR') { node.remove(); continue; }
          if (node.nodeType === Node.ELEMENT_NODE && /^(P|DIV|SPAN|STRONG|EM|B|I|U|H[1-6])$/.test(node.nodeName)) {
            trimEnd(node);
            if (!node.hasChildNodes()) { node.remove(); continue; }
          }
          break;
        }
      };
      trimEnd(description);
      data.label ||= description.dataset.factsImage || data.images.find(img => factsAlt.test(img.alt || ''))?.src;
      if (data.label) description.dataset.factsImage = data.label;
      description.hidden = false;
    }
    $('#facts').hidden = !data.label;
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: data.currency }).format(cents / 100);
    const form = $('#purchase-form');
    const quantity = $('#quantity');
    const variantInput = $('#product-variant');
    const frequency = $('#delivery-frequency');
    const planInput = $('#selling-plan');
    const subscription = $('input[name="plan"][value="subscription"]');
    const once = $('input[name="plan"][value="once"]');
    const submitButtons = [...document.querySelectorAll('button[type="submit"][form="purchase-form"], #purchase-form button[type="submit"]')];
    let variant;
    let busy = false;
    let purchaseFeedback = '';
    let feedbackTimer;
    let view = 0;
    let bag = null;
    const plan = () => subscription.checked ? variant.plans.find(item => String(item.id) === frequency.value) : null;
    function setError(node, message = '') {
      node.textContent = message;
      node.hidden = !message;
    }
    async function request(path, body) {
      const response = await fetch(data.root + path, {
        credentials: 'same-origin', signal,
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { method: 'POST', body: JSON.stringify(body) } : {})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to update your bag. Please try again.');
      return result;
    }
    function updatePurchase() {
      const rule = variant.quantityRule || {};
      const min = rule.min || 1;
      const step = rule.increment || 1;
      const max = rule.max || 99;
      const requested = Math.max(min, Math.min(max, Number(quantity.value) || min));
      const count = min + Math.floor((requested - min) / step) * step;
      quantity.min = min; quantity.max = max; quantity.step = step; quantity.value = count;
      $('#decrease').disabled = busy || count <= min;
      $('#increase').disabled = busy || count + step > max;
      const allocation = plan();
      planInput.disabled = !allocation;
      planInput.value = allocation ? allocation.id : '';
      const price = allocation ? allocation.price : variant.price;
      $('#total').textContent = money(price * count);
      $('#mobile-total').textContent = money(price * count);
      $('#mobile-plan').textContent = allocation ? `Subscription · ${allocation.name}` : `One-time · Qty ${count}`;
      $('#one-time-price').textContent = money(variant.price);
      const selectedAllocation = variant.plans.find(item => String(item.id) === frequency.value);
      if (selectedAllocation) {
        $('#subscription-price').textContent = money(selectedAllocation.price);
        $('#subscription-discount').textContent = variant.price ? Math.round((variant.price - selectedAllocation.price) / variant.price * 100) : 0;
      }
      const unavailable = !variant.available || (variant.requiresPlan && !allocation);
      submitButtons.forEach(button => {
        button.disabled = busy || unavailable;
        const state = busy ? 'loading' : purchaseFeedback;
        button.dataset.purchaseState = state;
        button.dataset.purchaseLabel = busy ? 'Adding…' : state === 'success' ? 'Added ✓' : state === 'error' ? 'Try again' : '';
        button.setAttribute('aria-busy', String(busy));
        if (state) button.setAttribute('aria-label', button.dataset.purchaseLabel);
        else button.removeAttribute('aria-label');
      });
      $('#add-label').textContent = busy ? 'Adding…' : unavailable ? 'Sold out' : 'Add to cart';
      form.setAttribute('aria-busy', String(busy));
      [variantInput, frequency, quantity, subscription, once].forEach(input => { input.disabled = busy; });
    }
    function selectVariant() {
      variant = data.variants.find(item => String(item.id) === variantInput.value) || data.variants[0];
      const previous = frequency.value;
      frequency.replaceChildren(...variant.plans.map(item => new Option(item.name.replace(/^Delivery every /i, ''), item.id)));
      if (variant.plans.some(item => String(item.id) === previous)) frequency.value = previous;
      $('.purchase-option.subscription').hidden = !variant.plans.length;
      $('.one-time-option').hidden = variant.requiresPlan;
      if (!variant.plans.length) once.checked = true;
      else if (variant.requiresPlan) subscription.checked = true;
      const imageIndex = data.images.findIndex(image => image.id === variant.imageId);
      if (imageIndex >= 0) selectView(imageIndex);
      updatePurchase();
    }
    on(variantInput, 'change', () => {
      selectVariant();
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    });
    on(frequency, 'change', updatePurchase);
    [subscription, once].forEach(input => on(input, 'change', updatePurchase));
    on(quantity, 'change', updatePurchase);
    on(quantity, 'input', () => { if (quantity.value && quantity.validity.valid) updatePurchase(); });
    on(quantity, 'blur', updatePurchase);
    on($('#decrease'), 'click', () => { quantity.stepDown(); updatePurchase(); });
    on($('#increase'), 'click', () => { quantity.stepUp(); updatePurchase(); });
    function selectView(index) {
      if (!data.images.length || !$('#hero-image')) return;
      view = (index + data.images.length) % data.images.length;
      $('#hero-image').src = data.images[view].src;
      $('#hero-image').alt = data.images[view].alt;
      document.querySelectorAll('.thumbnail').forEach((button, i) => {
        button.classList.toggle('selected', i === view);
        button.setAttribute('aria-pressed', String(i === view));
      });
      const selected = $('.thumbnail.selected');
      const strip = selected?.parentElement;
      if (strip) {
        const bounds = strip.getBoundingClientRect();
        const itemBounds = selected.getBoundingClientRect();
        const inset = 6;
        let offset = 0;
        if (itemBounds.left < bounds.left + inset) offset = itemBounds.left - bounds.left - inset;
        else if (itemBounds.right > bounds.right - inset) offset = itemBounds.right - bounds.right + inset;
        if (offset) strip.scrollTo({left: strip.scrollLeft + offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
    }
    document.querySelectorAll('.thumbnail').forEach(button => on(button, 'click', () => selectView(Number(button.dataset.view))));
    on($('#previous'), 'click', () => selectView(view - 1));
    on($('#next'), 'click', () => selectView(view + 1));
    function showImage(label) {
      if (label && !data.label) return;
      const imageUrl = new URL(label ? data.label : $('#hero-image').src, location.href);
      if (!label && imageUrl.searchParams.has('width')) imageUrl.searchParams.set('width', '2400');
      $('#expanded-image').src = imageUrl.href;
      $('#expanded-image').alt = label ? 'Manufacturer supplement facts label' : $('#hero-image').alt;
      $('#image-dialog').classList.toggle('is-supplement-facts', label);
      $('#image-navigation').hidden = label || data.images.length < 2;
      $('#image-position').textContent = label ? '' : `${view + 1} / ${data.images.length}`;
      if (!$('#image-dialog').open) $('#image-dialog').showModal();
    }
    function moveExpandedImage(direction) {
      if (!$('#image-dialog').open || $('#image-dialog').classList.contains('is-supplement-facts') || data.images.length < 2) return;
      selectView(view + direction);
      showImage(false);
    }
    on($('#image-previous'), 'click', () => moveExpandedImage(-1));
    on($('#image-next'), 'click', () => moveExpandedImage(1));
    on($('#image-dialog'), 'keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      moveExpandedImage(event.key === 'ArrowLeft' ? -1 : 1);
    });
    on($('#zoom'), 'click', () => showImage(false));
    on($('#facts'), 'click', () => showImage(true));
    const element = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text != null) node.textContent = text;
      return node;
    };
    function renderBag() {
      const container = $('#cart-content');
      container.replaceChildren();
      $('#cart-count').textContent = bag.item_count;
      $('#cart-count').hidden = !bag.item_count;
      $('#bag-count').textContent = bag.item_count;
      $('#bag-subtotal').textContent = money(bag.total_price);
      $('.checkout-button').hidden = !bag.item_count;
      if (!bag.items.length) { container.textContent = 'Your bag is currently empty.'; return; }
      for (const item of bag.items) {
        const row = element('div', 'cart-item');
        const img = element('img');
        const imageUrl = item.featured_image?.url || item.image || data.photo;
        if (imageUrl) img.src = imageUrl;
        else img.hidden = true;
        img.alt = item.product_title;
        const detail = element('div', 'cart-item-detail');
        const title = element('h3', '', item.product_title);
        const description = element('p', '', item.selling_plan_allocation?.selling_plan?.name || 'One-time purchase');
        const price = element('strong', '', money(item.final_line_price));
        const controls = element('div', 'bag-item-controls');
        const qty = element('span', '', `Qty ${item.quantity}`);
        const remove = element('button', '', 'Remove');
        remove.type = 'button';
        remove.setAttribute('aria-label', `Remove ${item.product_title} from bag`);
        on(remove, 'click', async () => {
          const controls = [...container.querySelectorAll('button')];
          controls.forEach(button => { button.disabled = true; });
          setError($('#cart-error'));
          try {
            bag = await request('cart/change.js', { id: item.key, quantity: 0 });
            $('#bag-confirmation').hidden = true;
            renderBag();
            (container.querySelector('button') || $('#cart-dialog .close-dialog')).focus();
          } catch (error) {
            if (error.name !== 'AbortError') setError($('#cart-error'), error.message);
          } finally { controls.forEach(button => { button.disabled = false; }); }
        });
        controls.append(qty, remove);
        detail.append(title, description, price, controls);
        row.append(img, detail); container.append(row);
      }
    }
    async function refreshBag() { bag = await request('cart.js'); renderBag(); }
    on(form, 'submit', async event => {
      event.preventDefault();
      if (busy || !variant.available) return;
      updatePurchase();
      const allocation = plan();
      const item = { id: variant.id, quantity: Number(quantity.value) };
      if (allocation) item.selling_plan = allocation.id;
      clearTimeout(feedbackTimer);
      purchaseFeedback = '';
      busy = true; updatePurchase(); setError($('#purchase-error')); setError($('#cart-error'));
      $('#status').textContent = 'Adding to your cart…';
      let added = false;
      try {
        if (data.useStoreCart) await window.photoStoryCart.add(item, event.submitter);
        else await request('cart/add.js', { items: [item] });
        added = true;
        await refreshBag();
        $('#status').textContent = `${item.quantity} added to your bag.`;
        $('#bag-confirmation').hidden = false;
        // Beyond owns the native cart markup, styling and quantity controls.
        if (!data.useStoreCart && !$('#cart-dialog').open) $('#cart-dialog').showModal();
      } catch (error) {
        if (error.name !== 'AbortError') setError($('#purchase-error'), added ? 'Added to your bag, but the bag could not refresh. Open your bag to check your items before adding again.' : error.message);
      } finally {
        busy = false;
        purchaseFeedback = added ? 'success' : 'error';
        if (!added) $('#status').textContent = 'Could not add to cart. Please try again.';
        updatePurchase();
        feedbackTimer = setTimeout(() => { purchaseFeedback = ''; updatePurchase(); }, 2500);
      }
    });
    on($('#open-cart'), 'click', async event => {
      event.preventDefault();
      if (data.useStoreCart) {
        try { await window.photoStoryCart.open(); }
        catch (error) { setError($('#purchase-error'), error.message); }
        return;
      }
      $('#bag-confirmation').hidden = true;
      $('#cart-content').textContent = 'Loading your bag…';
      $('.checkout-button').hidden = true;
      setError($('#cart-error'));
      $('#cart-dialog').showModal();
      try { await refreshBag(); } catch (error) {
        if (error.name !== 'AbortError') { $('#cart-content').textContent = ''; setError($('#cart-error'), error.message); }
      }
    });
    document.querySelectorAll('.close-dialog,.continue-button').forEach(button => on(button, 'click', () => button.closest('dialog').close()));
    document.querySelectorAll('dialog').forEach(dialog => on(dialog, 'click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }));
    on($('.menu-toggle'), 'click', () => {
      const open = $('#navigation').classList.toggle('open');
      $('.menu-toggle').setAttribute('aria-expanded', String(open));
      $('.menu-toggle').setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
    });
    on(document, 'keydown', event => {
      if (event.key === 'Escape') { $('#navigation').classList.remove('open'); $('.menu-toggle').setAttribute('aria-expanded', 'false'); }
    });
    const mobileQuery = matchMedia('(max-width:768px)');
    let primaryVisible = false;
    const syncMobile = () => { $('#mobile-purchase').hidden = !mobileQuery.matches || primaryVisible; };
    const observer = new IntersectionObserver(([entry]) => { primaryVisible = entry.isIntersecting; syncMobile(); }, { threshold: 0 });
    observer.observe($('.purchase-actions .add-to-cart'));
    on(mobileQuery, 'change', syncMobile);
    selectVariant();
    refreshBag().catch(() => {});
    on(window, 'focus', () => refreshBag().catch(() => {}));
    on(window, 'photo-story:cart-updated', () => refreshBag().catch(() => {}));
    window.photoStoryCleanup = () => { clearTimeout(feedbackTimer); controller.abort(); observer.disconnect(); };
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
